 const dateFormat = () => {
  const date = new Date()
   const y = date.getFullYear();
   let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
   let d = date.getDate();
   d = d < 10 ? ('0' + d) : d;
   let h = date.getHours();
   h=h < 10 ? ('0' + h) : h;
   let minute = date.getMinutes();
   minute = minute < 10 ? ('0' + minute) : minute;
   let second=date.getSeconds();
   second=second < 10 ? ('0' + second) : second;
   return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
 }
import store from '../store'
const getSettingConfig = {
  getInfo(data) {
    const list = store.state.status.web_info
    for (const key in list) {
      if (list[key].menu_name === data) {
        return  list[key].value
      }
    }
  },
}

export {getSettingConfig,dateFormat}




// WEBPACK FOOTER //
// ./src/utils/index.js